{
  "pages": [
    {
      "name": "page1",
      "elements": [
        {
          "type": "panel",
          "name": "panel5",
          "elements": [
            {
              "type": "dropdown",
              "name": "ControllerType",
              "title": "Controller product type",
              "isRequired": true,
              "choices": [
                {
                  "value": "BCCON1MS",
                  "text": "BCCON1MS ( SIM card )"
                },
                {
                  "value": "BCCON1ME",
                  "text": "BCCON1ME ( Ethernet )"
                }
              ]
            }
          ],
          "title": "Grundfos BuildingConnect Controller "
        },
        {
          "type": "panel",
          "name": "panel1",
          "elements": [
            {
              "type": "dropdown",
              "name": "building_type",
              "title": "Building type",
              "choices": [
                {
                  "value": "hotel_restaurant",
                  "text": "Hotel Restaurant / café "
                },
                {
                  "value": "SportFacility",
                  "text": "Sport facility"
                },
                {
                  "value": "RetailStore",
                  "text": "Retail store"
                },
                {
                  "value": "ShoppingMall",
                  "text": "Shopping mall"
                },
                {
                  "value": "OfficeBuilding",
                  "text": "Office building"
                },
                {
                  "value": "Hospital",
                  "text": "Hospital"
                },
                {
                  "value": "MedicalCenterOrClinic",
                  "text": "Medical center or clinic"
                },
                {
                  "value": "NursingHome",
                  "text": "Nursing home"
                },
                {
                  "value": "MixedUse",
                  "text": "Mixed use"
                },
                {
                  "value": "Residential4",
                  "text": "Residential building, up to 4 apartments"
                },
                {
                  "value": "Residential8",
                  "text": "Residential building, up to 8 apartments"
                },
                {
                  "value": "Residential15",
                  "text": "Residential building, up to 15 apartments"
                },
                {
                  "value": "Residential30",
                  "text": "Residential building, up to 30 apartments"
                },
                {
                  "value": "Residential60",
                  "text": "Residential building, up to 60 apartments"
                },
                {
                  "value": "ResidentialMoreThan60",
                  "text": "Residential building, more than 60 apartments"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "construction_year",
              "title": "Construction Year",
              "choices": [
                {
                  "value": "-1900",
                  "text": "Before 1900"
                },
                {
                  "value": "1900-1939",
                  "text": "From 1900 to 1939"
                },
                {
                  "value": "1940-1959",
                  "text": "From 1940 to 1959"
                },
                {
                  "value": "1960-1979",
                  "text": "From 1960 to 1979"
                },
                {
                  "value": "1980-1989",
                  "text": "From 1980 to 1989"
                },
                {
                  "value": "1990-1999",
                  "text": "From 1990 to 1999"
                },
                {
                  "value": "2000-2009",
                  "text": "From 2000 to 2009"
                },
                {
                  "value": "2010-",
                  "text": "From 2010"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "floors",
              "title": "Number of floors incl. ground floor.",
              "choices": [
                {
                  "value": "1",
                  "text": "1 floor"
                },
                {
                  "value": "2",
                  "text": "2 floors"
                },
                {
                  "value": "3",
                  "text": "3 floors"
                },
                {
                  "value": "4",
                  "text": "4 floors"
                },
                {
                  "value": "5",
                  "text": "5 floors"
                },
                {
                  "value": "6",
                  "text": "6 floors"
                },
                {
                  "value": "7",
                  "text": "7 floors"
                },
                {
                  "value": "8",
                  "text": "8 floors"
                },
                {
                  "value": "9",
                  "text": "9  floors"
                },
                {
                  "value": "10",
                  "text": "10 floors"
                },
                {
                  "value": "11",
                  "text": "11 floors"
                },
                {
                  "value": "12",
                  "text": "12 floors"
                },
                {
                  "value": "13-15",
                  "text": "13 to 15 floors"
                },
                {
                  "value": "15-",
                  "text": "More than 15 floors"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "building_footprint",
              "title": "Building footprint [m2]",
              "choices": [
                {
                  "value": "-100",
                  "text": "Up to 100 m2"
                },
                {
                  "value": "101-200",
                  "text": "From 101 to 200 m2"
                },
                {
                  "value": "201-300",
                  "text": "From 201 to 300 m2"
                },
                {
                  "value": "301-400",
                  "text": "From 301 to 400 m2"
                },
                {
                  "value": "401-500",
                  "text": "From 401 to 500 m2"
                },
                {
                  "value": "501-700",
                  "text": "From 501 to 700 m2"
                },
                {
                  "value": "701-1000",
                  "text": "From 701 to 1000 m2"
                },
                {
                  "value": "1001-1500",
                  "text": "From 1001 to 1500 m2"
                },
                {
                  "value": "1501-2500",
                  "text": "From 1501 to 2500 m2"
                },
                {
                  "value": "2501-5000",
                  "text": "From 2501 to 5000 m2"
                },
                {
                  "value": "5000-",
                  "text": "More than 5000 m2"
                }
              ]
            }
          ],
          "title": "Building info",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "panel4",
          "elements": [
            {
              "type": "dropdown",
              "name": "energy_source_hot_water",
              "title": "Energy source for domestic hot water heating",
              "choices": [
                {
                  "value": "NaturalGas",
                  "text": "Natural gas"
                },
                {
                  "value": "Oil",
                  "text": "Oil"
                },
                {
                  "value": "DistrictEnergy",
                  "text": "District energy"
                },
                {
                  "value": "Electricity",
                  "text": "Electricity"
                },
                {
                  "value": "Other",
                  "text": "Other"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "energy_source_space_heating",
              "title": "Energy source for space heating",
              "choices": [
                {
                  "value": "NaturalGas",
                  "text": "Natural gas"
                },
                {
                  "value": "Oil",
                  "text": "Oil"
                },
                {
                  "value": "DistrictEnergy",
                  "text": "District energy"
                },
                {
                  "value": "Electricity",
                  "text": "Electricity"
                },
                {
                  "value": "Other",
                  "text": "Other"
                }
              ]
            }
          ],
          "title": "Energy Source"
        },
        {
          "type": "panel",
          "name": "panel3",
          "elements": [
            {
              "type": "dropdown",
              "name": "electrical_power_capacity",
              "title": "Installed electrical power capacity [kW]",
              "choices": [
                {
                  "value": "-50",
                  "text": "Up to 50 kW"
                },
                {
                  "value": "51-100",
                  "text": "From 51 to 100 kW"
                },
                {
                  "value": "101-200",
                  "text": "From 101 to 200 kW"
                },
                {
                  "value": "201-400",
                  "text": "From 201 to 400 kW"
                },
                {
                  "value": "401-800",
                  "text": "From 401 to 800 kW"
                },
                {
                  "value": "800-",
                  "text": "More than 800 kW"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "heating_capacity",
              "title": "Installed heating capacity for space heating incl. dom. hot water, [kW]",
              "choices": [
                {
                  "value": "-50",
                  "text": "Up to 50 kW"
                },
                {
                  "value": "51-100",
                  "text": "From 51 to 100 kW"
                },
                {
                  "value": "101-200",
                  "text": "From 101 to 200 kW"
                },
                {
                  "value": "201-400",
                  "text": "From 201 to 400 kW"
                },
                {
                  "value": "401-800",
                  "text": "From 401 to 800 kW"
                },
                {
                  "value": "800-",
                  "text": "More than 800 kW"
                }
              ]
            }
          ],
          "title": "Power capacity"
        },
        {
          "type": "panel",
          "name": "panel2",
          "elements": [
            {
              "type": "text",
              "name": "annual_electricity_consumption",
              "title": "Annual electricity consumption [kWh]",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "annual_consumption_space_heating",
              "title": "Annual consumption for space heating  [kWh]",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "annual_consumption_hot_water",
              "title": "Annual energy consumption for domestic hot water heating",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "annual_water_consumption",
              "title": "Annual water consumption [m3]",
              "inputType": "number"
            }
          ],
          "title": "Consumption"
        },
        {
          "title": "Notes",
          "type": "panel",
          "name": "panel_notes",
          "elements": [
            {
              "type": "textarea",
              "name": "plant_room_notes",
              "title": "Notes"
            }
          ]
        }
      ]
    }
  ]
}
